import { useState, FocusEventHandler } from 'react'

export interface UseFocusFieldReturn<TFieldName extends string> {
  focusedField: TFieldName | null
  registerFocus: (name: TFieldName) => {
    onFocus: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
    onBlur: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
  }
}

export const useFocusField = <TFieldName extends string = string>(): UseFocusFieldReturn<TFieldName> => {
  const [focusedField, setFocusedField] = useState<TFieldName | null>(null)

  const registerFocus = (name: TFieldName) => {
    const onFocus: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> = () => setFocusedField(name)
    const onBlur: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> = () => setFocusedField(null)
    return { onFocus, onBlur }
  }

  return { focusedField, registerFocus }
}
